import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import * as ReqType from '../../types/ServerRequests';
import { InfoProfile } from './internalComponents/InfoProfile';
import { CoursProfile } from './internalComponents/CoursProfile';
import { MediaProfile } from './internalComponents/MediaProfile';
import './internalComponents/Profile.css';
import { ListFrais } from './internalComponents/ListFrais';
import LoginServices from '../../services/LoginServices';
import { DocumentsProfile } from './internalComponents/DocumentsProfile';
import { LoaderButton } from '../genericComponents/Button/LoaderButton';
import { ModifMdpProfileShow } from './internalComponents/ModifMdpProfileShow';
import { ListeEvent } from './internalComponents/ListeEvent';
import { UserService } from '../../services/UserService';
import { TagCard } from '../genericComponents/Tag/TagCard';
import { MediaService } from '../../services/MediaService';

interface State {
    profil?: ReqType.UserView;
    frais: ReqType.Frais[];
    cours: ReqType.Course[];
    photoProfile: string;
}

interface Props {
    match: {
        path: string;
        url: string;
        isExact: boolean;
        params: {
            name: string;
        }
    };
}

/**
 * permet l'affichage de la page de profil depuis un compte admin
 */
export class ShowProfilePage extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            frais: [],
            cours: [],
            photoProfile: require('./internalComponents/photoProfile.PNG')
        };
        const userType = LoginServices.getInstance().getType();
        this.getProfil();
        if (userType === UserRole.ADMIN.toString() ||
            userType === UserRole.SEMI_PRO.toString()) {
            this.getFees();
        }
        this.getCourses();
    }

    public getProfil(): void {
        var userId = Number.parseInt(this.props.match.params.name);
        UserService.getInstance().getUser(userId).then(
            (response: ReqType.UserView) => {
                if (response.userProfile === null || response.userProfile.photo_profil === null) {
                    this.setState({
                        profil: response,
                        photoProfile: require(
                            '../ProfilePage/internalComponents/photoProfile.PNG')
                    });
                } else {
                    this.setState({
                        profil: response,
                        photoProfile: MediaService.getInstance().getBaseURL() +
                            response.userProfile!.photo_profil
                    });
                }
            }
        );
    }

    render() {
        var nom: string = '';
        if (this.state.profil !== null && this.state.profil !== undefined) {
            if (this.state.profil.userProfile !== null && this.state.profil.userProfile !== undefined) {
                nom = this.state.profil.userProfile!.nom + ' ' + this.state.profil.userProfile!.prenom;
            }
        } else {
            nom = '';
        }
        var infoProfil = undefined;
        if (this.state.profil !== undefined) {
            infoProfil = (
                <div className="col-12 rounded">
                    <InfoProfile
                        information={this.state.profil}
                        changeProfile={
                            (e: ReqType.UserView) => {
                                this.setState({ profil: e });
                            }
                        }
                    />
                </div>
            );
        }

        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                ]}
            >
                <div style={{ paddingTop: '10px' }}>
                    <div className="margin-top">
                        <img
                            src={this.state.photoProfile}
                            className="img-thumbnail mx-auto d-block rounded-circle"
                            alt="Photo de profil"
                            width="200"
                            height="200"
                        />
                        <h1 className="text-center">
                            {nom}
                        </h1>
                    </div>

                    <div className="col-12 btn-group">
                        {this.getUserPromoteButtons()}
                    </div>

                    {infoProfil}
                    <div className="col-12">
                        <ModifMdpProfileShow userId={Number.parseInt(this.props.match.params.name)} />
                    </div>
                    <div className="col-12">
                        {this.state.profil === undefined ? undefined :
                            <DocumentsProfile user_id={this.state.profil.id.toString()} hidden={false} />
                        }
                    </div>

                    <div className="col-12">
                        <CoursProfile cours={this.state.cours} />
                    </div>

                    <div className="col-12">
                        {this.state.profil === undefined ? undefined :
                            <ListeEvent listEvent={this.state.profil.events} />
                        }
                    </div>

                    <div className="col-12">
                        <ListFrais frais={this.state.frais} />
                    </div>

                    <div className="col-lg-12">
                        <MediaProfile
                            media={
                                this.state.profil === undefined ? [] : this.state.profil.media
                            }
                            displayControls={false}
                            setMedia={
                                (m: ReqType.Media[]) => {
                                    if (this.state.profil !== undefined) {
                                        var profile = UserService.getInstance().duplicateUserView(this.state.profil);
                                        profile.media = m;
                                        this.setState({ profil: profile });
                                    }
                                }
                            }
                        />
                    </div>

                    <div className="col-12" style={{ marginBottom: '20px' }}>
                        <TagCard
                            ownedTags={this.state.profil === undefined ? [] : this.state.profil.tags}

                            setOwned={
                                (tags: ReqType.Tag[]) => {
                                    if (this.state.profil !== undefined) {
                                        var newProfil = UserService.getInstance().duplicateUserView(this.state.profil);
                                        newProfil.tags = tags;
                                        this.setState({ profil: newProfil });
                                    }
                                }
                            }
                            addTag={
                                (tag: ReqType.Tag) => {
                                    return UserService
                                        .getInstance()
                                        .addTag(Number.parseInt(this.props.match.params.name), tag.id);
                                }
                            }
                            removeTag={
                                (tag: ReqType.Tag) => {
                                    return UserService
                                        .getInstance()
                                        .removeTag(Number.parseInt(this.props.match.params.name), tag.id);
                                }
                            }
                        />
                    </div>

                </div>

            </PageChorinitia>
        );
    }

    private getUserPromoteButtons() {
        if (
            this.state.profil === undefined ||
            this.state.profil.user_type_id === UserRole.NOT_LOGED_IN ||
            this.state.profil.user_type_id === UserRole.USER
        ) {
            return undefined;
        } else {
            var arr: JSX.Element[] = [];
            if (this.state.profil.user_type_id !== UserRole.MEMBER) {
                arr.push(
                    <LoaderButton
                        className="btn btn-outline-secondary"
                        modalTitle="Changement en membre"
                        confirmation={true}
                        key="membre"
                        modalBody={
                            'Etes vous sur de vouloir changer ' +
                            (this.state.profil === undefined ? '' : this.state.profil.username) +
                            ' en membre?'
                        }
                        onClick={
                            () => {
                                return (UserService.getInstance()
                                    .promoteUser(
                                        Number.parseInt(this.props.match.params.name),
                                        UserRole.MEMBER
                                    )
                                );
                            }
                        }
                    >
                        Changer en membre
                    </LoaderButton>
                );
            }
            if (this.state.profil.user_type_id !== UserRole.SEMI_PRO) {
                arr.push(
                    <LoaderButton
                        className="btn btn-outline-secondary"
                        modalTitle="Changement en semi-pro"
                        confirmation={true}
                        key="semi-pro"
                        modalBody={
                            'Etes vous sur de vouloir changer ' +
                            (this.state.profil === undefined ? '' : this.state.profil.username) +
                            ' en semi-pro?'
                        }
                        onClick={
                            () => {
                                return (UserService.getInstance()
                                    .promoteUser(
                                        Number.parseInt(this.props.match.params.name),
                                        UserRole.SEMI_PRO
                                    )
                                );
                            }
                        }
                    >
                        Changer en semi-pro
                    </LoaderButton>
                );
            }
            if (this.state.profil.user_type_id !== UserRole.ADMIN) {
                arr.push(
                    <LoaderButton
                        className="btn btn-outline-secondary"
                        modalTitle="Changement en admin"
                        confirmation={true}
                        key="admin"
                        modalBody={
                            'Etes vous sur de vouloir changer ' +
                            (this.state.profil === undefined ? '' : this.state.profil.username) +
                            ' en admin?'
                        }
                        onClick={
                            () => {
                                return (UserService.getInstance()
                                    .promoteUser(
                                        Number.parseInt(this.props.match.params.name),
                                        UserRole.ADMIN
                                    )
                                );
                            }
                        }
                    >
                        Changer en admin
                    </LoaderButton>
                );
            }
            return arr;
        }
    }

    private getCourses(): void {
        UserService.getInstance()
            .getUserCourses(Number.parseInt(this.props.match.params.name))
            .then(
                (response: ReqType.Course[] | string) => {
                    if (response !== '') {
                        this.setState({ cours: response });
                    }
                }
            ).catch(
                (error) => {
                    // alert(error);
                }
            );
    }

    private getFees(): void {
        UserService
            .getInstance()
            .getUserFees(Number.parseInt(this.props.match.params.name))
            .then(
                (response: ReqType.Frais[]) => {
                    // alert('Profile loaded');
                    this.setState({ frais: response });
                }
            ).catch(
                (error) => {
                    // alert(error);
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/ShowProfilePage.tsx